import { createSlice } from "@reduxjs/toolkit";
import * as action from "../actions/currentProfileActions";

export const currentProfileSlicer = createSlice({
  name: "currentProfile",
  initialState: {
    data: null,
    bookmarks: null,
    loading: true,
    errors: null,
  },
  reducers: {
    addNotification: (state, action) => {
      if (state.data) {
        state.data.notifications.unshift(action.payload);
      }
    },
  },
  extraReducers: {
    [action.signUp.pending]: (state) => {
      state.loading = true;
    },
    [action.verifyEmail.pending]: (state) => {
      state.loading = true;
    },
    [action.signIn.pending]: (state) => {
      state.loading = true;
    },
    [action.getCurrentProfile.pending]: (state) => {
      state.loading = true;
    },
    [action.signUp.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status !== 200) {
        state.errors = data.errors;
      }
      state.loading = false;
    },
    [action.verifyEmail.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.data = data;
      } else {
        state.errors = data.errors;
      }
      state.loading = false;
    },
    [action.signIn.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.data = data;
      } else {
        state.errors = data.errors;
      }
      state.loading = false;
    },
    [action.signOut.fulfilled]: (state, action) => {
      const { status } = action.payload;
      if (status === 200) {
        state.data = null;
      }
    },
    [action.getCurrentProfile.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.data = data;
      }
      state.loading = false;
    },
    [action.addBookmark.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.data = data;
      }
    },
    [action.removeBookmark.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.data = data;
      }
    },
    [action.editProfile.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.data = data;
      }
    },
    [action.uploadAvatar.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.data = data;
      }
    },
    [action.uploadBanner.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.data = data;
      }
    },
    [action.getBookmarks.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.bookmarks = data;
      }
    },

    [action.updateFollowing.fulfilled]: (state, action) => {
      const user = action.payload.profile;
      const isFollowAction = action.payload.action === "follow";

      if (isFollowAction) {
        if (!state.data.following.some((f) => f._id === user._id)) {
          state.data = {
            ...state.data,
            following: [...state.data.following, user],
          };
        }
      } else {
        state.data = {
          ...state.data,
          following: state.data.following.filter((f) => f._id !== user._id),
        };
      }
    },
    [action.markNotificationsRead.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.data = data;
      }
    },
    // Inside your extraReducers
    [action.deleteCurrentProfile.pending]: (state) => {
      state.loading = true;
      state.errors = null;
    },
    [action.deleteCurrentProfile.fulfilled]: (state, action) => {
      const { status, data } = action.payload;
      if (status === 200) {
        state.data = null; // Clear user data on successful delete
        state.loading = false;
        state.bookmarks = null;
      } else {
        state.errors = data.error || data.errors;
      }
      state.loading = false;
    },
    [action.deleteCurrentProfile.rejected]: (state, action) => {
      state.loading = false;
      state.errors = "Server connection failed";
    },
    [action.updateCurrentUsername.pending]: (state) => {
      state.loading = true;
      state.errors = null;
    },
    [action.updateCurrentUsername.fulfilled]: (state, action) => {
      const { status, data } = action.payload;

      if (status === 200) {
        // We only update the username field so we don't lose the rest of the profile data
        if (state.data) {
          state.data.username = data.username;
        }
        state.errors = null;
      } else {
        // Capture the 400 or 409 error messages from your controller
        state.errors = data.error;
      }
      state.loading = false;
    },
    [action.updateCurrentUsername.rejected]: (state) => {
      state.loading = false;
      state.errors = "Connection to server failed.";
    },
  },
});

export default currentProfileSlicer.reducer;
